module.exports = __webpack_public_path__ + "img/czleader5.fc63eede.png";